import React from "react";
import cn from "classnames";
import styles from "./Panel.module.sass";
import Icon from "../../../components/Icon";

const Panel = ({ selectedCount = 0, onDelete, visible = false }) => {
  if (!visible) return null;

  return (
    <div className={cn("panel", styles.panel)}>
      <div className={styles.info}>
        <Icon name="check-all" size="24" />
        <span>{selectedCount} demande{selectedCount > 1 ? 's' : ''}</span> sélectionnée{selectedCount > 1 ? 's' : ''}
      </div>
      <div className={styles.actions}>
        <button 
          className={cn("button-stroke-red", styles.button)}
          onClick={onDelete}
        >
          <Icon name="trash" size="16" />
          Supprimer
        </button>
      </div>
    </div>
  );
};

export default Panel;
